if (window.innerWidth > 1024) {
  var swiper3 = new Swiper(".overview-mySwiper", {
    slidesPerView: 5,
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
    mousewheel: {
      forceToAxis: true,
    },
    breakpoints: {
      991: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
      1367: {
        slidesPerView: 5,
        spaceBetween: 10,
      },
    },
  });
  var swiper2 = new Swiper(".overview-mySwiper2", {
    autoHeight: true,
    allowTouchMove: false,
    navigation: {
      nextEl: ".block_product-overview-tab-info .block_slider-right-arrow ",
      prevEl: ".block_product-overview-tab-info .block_slider-left-arrow",
    },
    mousewheel: {
      forceToAxis: true,
    },
    thumbs: {
      swiper: swiper3,
    },
  });
}

let moboverviewTitle = document.querySelectorAll(".block_product-overview-tab-mobile-tab");

moboverviewTitle.forEach((event) => {
  event.addEventListener("click", (tab) => {
    let target = tab.target;
    let dataTitle = target.closest(".swiper-slide").querySelector(".over-view-data-tab");
    target.classList.toggle("active");
    dataTitle.classList.toggle("active");
  });
});

// ==============overview=======


var swiper = new Swiper(".block_product-overview-content-closerlook-slider", {
	slidesPerView: 4,
	spaceBetween: 20,
	pagination: {
		el: ".block_product-overview-content-closerlook-slider .swiper-pagination",
		clickable: true,
	},
  mousewheel: {
    forceToAxis: true,
  },
    breakpoints: {
      280: {
        slidesPerView: 1,      
        centeredSlides: true,
        centeredSlidesBounds: true,
      },
      749: {
        slidesPerView: 2,  
      },
      1025:{
        slidesPerView: 3,  
      },
      1440: {
        slidesPerView: 4,
      }
    },
	navigation: {
		nextEl: ".block_product-overview-content-closerlook .block_slider-right-arrow",
		prevEl: ".block_product-overview-content-closerlook .block_slider-left-arrow",
	},
});
